import { authGet, authPost } from './http';

// --- wire types (mirror services/api internal/ads/delivery_model.go) ---

/** The slots the fan app can request an ad for. Must match the server's
 *  ads.Slot* constants — a placement bought for "home_feed" fills this slot. */
export type AdSlot = 'home_feed' | 'match_center' | 'stories' | 'wallet';

export interface ServedAd {
  placement_id: string;
  slot: AdSlot;
  title: string;
  copy?: string;
  /** API-relative blob path — run it through resolveMediaUrl before rendering. */
  image_url?: string;
  cta_text?: string;
  cta_url?: string;
  sponsor_name?: string;
}

export interface AdEvent {
  placement_id: string;
  impressions: number;
  clicks: number;
}

/** Fetches the ad for a slot. A null ad means the slot is unsold — a normal
 *  outcome, so the caller renders nothing rather than showing an error. */
export const getAd = (token: string, slot: AdSlot) =>
  authGet<{ ad: ServedAd | null }>(`/ads/serve?slot=${slot}`, token).then((r) => r.ad);

/** Reports a batch of impressions/clicks. Batched deliberately: a scrolling
 *  feed would otherwise fire a request per view. */
export const reportAdEvents = (token: string, events: AdEvent[]) =>
  authPost<{ applied: number }>('/ads/events', token, { events });
